import { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Button } from "components/Button";
import { Loader } from "components/Loader";
import { trackEvent } from "utils/tracking";
import { stopStrategy } from "features/Strategy/service";
import { stopIconV2 } from "assets/icons";
import { StartStrategyModalContainer } from "./StartStrategyModal.styles";

const StopStrategyModal = ({
  show = true,
  onHide,
  handleStopClick,
  strategyName,
  subscriptionId,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleStop = async () => {
    try {
      setLoading(true);

      await stopStrategy(subscriptionId);
      onHide();
      dispatch(
        toast({
          type: "info",
          header: "Strategy Stopped Successfully",
          body: "This strategy will stop trading immediately and your assets will be liquidated",
        })
      );
      handleStopClick();
      trackEvent({
        name: "cancel_strategy",
        label: "Strategy",
        strategy_name: strategyName,
        subscription_id: subscriptionId,
      });
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <StartStrategyModalContainer
      heading=""
      show={show}
      onHide={onHide}
      headingClass="modal-heading"
      className="stop-strategy-modal"
    >
      <div>
        <div className="strategy-modal-header ">
          <div className="d-flex justify-content-center">
            <img src={stopIconV2} className="img" />
          </div>
          <h2 className="heading">Stop Strategy</h2>

          <p className="description">
            No further trades will be placed by <b>{strategyName}</b> <br />
            All current positions will be automatically liquidated
          </p>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="strategy-modal-footer">
          <Button
            label="Stop Strategy"
            className="stop-btn"
            onClick={handleStop}
          />
          <Button onClick={onHide} label="Nevermind" className="cancel-btn" />
        </div>
      )}
    </StartStrategyModalContainer>
  );
};

export default StopStrategyModal;

StopStrategyModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  handleStopClick: PropTypes.func,
  subscriptionId: PropTypes.string,
  strategyName: PropTypes.string,
};

StopStrategyModal.displayName = "StopStrategyModal";
